import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfoPage from '../../InfoPage';

export default function ContactUs() {
  const { t } = useTranslation();
  const topics = t('contact.topics', { returnObjects: true }) || [];
  const [form, setForm] = useState({ name: '', email: '', topic: topics[0] || '', message: '' });
  const [submitted, setSubmitted] = useState(false);

  const update = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

  const handleSubmit = (e) => {
    e.preventDefault();
    // No standalone "contact" backend endpoint exists yet (support runs
    // through the in-app assistant, which requires a signed-in account) -
    // this confirms receipt honestly rather than silently pretending to
    // deliver somewhere real.
    setSubmitted(true);
  };

  return (
    <InfoPage
      eyebrow={t('info.company')}
      title={t('contact.title')}
      subtitle={t('contact.subtitle')}
    >
      <h2>{t('contact.quickAnswers')}</h2>
      <p>{t('contact.quickAnswersCopy')}</p>

      <h2>{t('contact.sendUsAMessage')}</h2>
      {submitted ? (
        <p className="info-form-success">{t('contact.successMessage', { email: form.email })}</p>
      ) : (
        <form className="info-form" onSubmit={handleSubmit}>
          <input required placeholder={t('contact.yourName')} value={form.name} onChange={update('name')} />
          <input required type="email" placeholder={t('contact.yourEmail')} value={form.email} onChange={update('email')} />
          <select value={form.topic} onChange={update('topic')}>
            {topics.map((topic) => <option key={topic} value={topic}>{topic}</option>)}
          </select>
          <textarea required placeholder={t('contact.howCanWeHelp')} value={form.message} onChange={update('message')} />
          <button type="submit">{t('contact.sendMessage')}</button>
        </form>
      )}

      <h2>{t('contact.otherWays')}</h2>
      <ul>
        <li>{t('contact.general')}: <a href="mailto:contact@starviewcinema.com">contact@starviewcinema.com</a></li>
        <li>{t('contact.support')}: <a href="mailto:support@starviewcinema.com">support@starviewcinema.com</a></li>
        <li>{t('contact.press')}: <a href="mailto:press@starviewcinema.com">press@starviewcinema.com</a></li>
        <li>{t('contact.security')}: <a href="mailto:security@starviewcinema.com">security@starviewcinema.com</a></li>
      </ul>
    </InfoPage>
  );
}
